
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { formatDateTime } from "@/utils/admin-utils";

interface ParkingSpotsTabProps {
  spots: any[];
}

export const ParkingSpotsTab = ({ spots }: ParkingSpotsTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Parking Spots</CardTitle>
        <CardDescription>All registered parking spots</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {spots.map((spot) => (
            <Card key={spot.id} className="p-4">
              <div className="flex justify-between items-start">
                <div className="flex-grow">
                  <div className="flex justify-between items-center">
                    <h3 className="font-semibold text-lg">{spot.address}</h3>
                    <span className={`px-3 py-1 rounded-full text-xs ${
                      spot.is_available ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {spot.is_available ? 'Available' : 'Unavailable'}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="space-y-2">
                      <p className="text-sm">
                        <span className="font-medium">Owner Name:</span> {spot.owner_name}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Owner Email:</span> {spot.owner_email}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Owner Phone:</span> {spot.owner_phone}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Price:</span> ${spot.price_per_hour}/hour
                      </p>
                    </div>
                    <div className="space-y-2">
                      <p className="text-sm">
                        <span className="font-medium">Vehicle Type:</span> {spot.vehicle_type}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Security Type:</span> {spot.security_type}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Parking Lots:</span> {spot.parking_lot_count}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Created:</span> {formatDateTime(spot.created_at)}
                      </p>
                    </div>
                  </div>
                  {spot.verification_document_url && (
                    <p className="text-sm mt-2">
                      <span className="font-medium">Verification Document:</span>{' '}
                      {spot.verification_document_type}
                    </p>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
